import { useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'

import SearchTrendingDestinations from 'components/Search/SearchForm/SearchTrendingDestinations'
import ContactContext from 'contexts/contactContext'
import TextButton from 'LuxKit/Button/TextButton'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Heading from 'LuxKit/Typography/Heading'

const Section = styled.div`
  flex-direction: column;
  margin: ${rem(50)} 0 ${rem(50)};
  align-items: center;
`

const MessageBlock = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`

const Message = styled(BodyText)`
  margin: ${rem(8)} 0;
`

const ContactNumberLink = styled(TextLink)`
  margin-inline-start: ${rem(4)};
`

const TrendingDestinationsSection = styled.div`
  display: flex;
  margin-top: ${rem(20)};
  width: 100%;
`

function HotelSearchNoSearchResultSection({ searchType }: { searchType?: App.SearchItem['searchType'] }) {
  const intl = useIntl()
  const currentContact = useContext(ContactContext)
  const localContact = currentContact.local

  const headingText = searchType === 'property'
    ? intl.formatMessage({
        id: '2hvu1M1n8AVDVCYjrRf7',
        defaultMessage: 'Sorry, we couldn’t find this offer',
      })
    : intl.formatMessage({
        id: 'EPkp7gT0K1xjxhwYxRoJ',
        defaultMessage: 'We couldn’t find any offers matching your search',
      })

  const speakToExpertText = intl.formatMessage({
    id: 'aLAcY_BmEw-L14ncDrDD',
    defaultMessage: 'Speak to one of our travel experts',
  })

  const speakToExpertButtonText = intl.formatMessage({
    id: '1TzSQrSvGX_WYeo8Y8It',
    defaultMessage: 'Speak to a travel expert',
  })

  const orText = intl.formatMessage({
    id: 'AcyohFyj7u0w0NVmeK_3',
    defaultMessage: 'OR',
  })

  const exploreTrendingText = intl.formatMessage({
    id: 'NYRECR4gYwdjhwcmHcuU',
    defaultMessage: 'Explore our trending destinations',
  })

  return (
    <Section>
      <MessageBlock>
        <Heading variant="heading4">{headingText}</Heading>
        <Message variant="large">
          <CSSBreakpoint min="tablet">
            {speakToExpertText}
            <ContactNumberLink href={`tel:${localContact.number}`} rel="nofollow">
              {localContact.humanReadable}
            </ContactNumberLink>
          </CSSBreakpoint>
          <CSSBreakpoint max="mobile">
            <TextButton startIcon={<LinePhoneIcon />} fit="mobile-full-width" kind="secondary" href={`tel:${localContact.number}`} rel="nofollow">{speakToExpertButtonText}</TextButton>
          </CSSBreakpoint>
        </Message>
        <Message variant="large">
          <BodyText variant="medium">{orText}</BodyText>
        </Message>
        <Message variant="large">
          {exploreTrendingText}
        </Message>
      </MessageBlock>
      <TrendingDestinationsSection>
        <SearchTrendingDestinations noTitle />
      </TrendingDestinationsSection>
    </Section>
  )
}

export default HotelSearchNoSearchResultSection
